import request from '@/utils/request'

// Saved routes (kayıtlı rotalar).
// Manager endpoints: /api/v2/user-routes/:targetUserId (auth: admin OR trainer-with-access).
// Admin moderation: /api/v2/admin/routes.

export const getUserRoutes = (targetUserId: string, search?: string) =>
  request({
    url: `/user-routes/${targetUserId}`,
    method: 'get',
    params: search ? { search } : {}
  })

export interface CreateRoutePayload {
  title?: string
  description?: string
  visibility?: string
  startLatitude: number
  startLongitude: number
  endLatitude: number
  endLongitude: number
  startAddress?: string
  endAddress?: string
}

// Creates a route on someone else's account. The backend requires all four
// coordinates and validates them; everything else is optional.
export const createUserRoute = (targetUserId: string, data: CreateRoutePayload) =>
  request({
    url: `/user-routes/${targetUserId}`,
    method: 'post',
    data
  })

export const getUserRouteDetail = (targetUserId: string, routeId: string) =>
  request({
    url: `/user-routes/${targetUserId}/${routeId}`,
    method: 'get'
  })

export const updateUserRoute = (
  targetUserId: string,
  routeId: string,
  data: { title?: string, description?: string, visibility?: string }
) =>
  request({
    url: `/user-routes/${targetUserId}/${routeId}`,
    method: 'put',
    data
  })

export const deleteUserRoute = (targetUserId: string, routeId: string) =>
  request({
    url: `/user-routes/${targetUserId}/${routeId}`,
    method: 'delete'
  })

export const getAllRoutes = (params: {
  search?: string
  visibility?: string
  limit?: number
  offset?: number
}) =>
  request({
    url: '/admin/routes',
    method: 'get',
    params
  })

export const setRouteVisibility = (routeId: string, visibility: string) =>
  request({
    url: `/admin/routes/${routeId}/visibility`,
    method: 'put',
    data: { visibility }
  })

export const adminDeleteRoute = (routeId: string) =>
  request({
    url: `/admin/routes/${routeId}`,
    method: 'delete'
  })
